import useCurrentDay from '$tablet-app/src/app/utils/useCurrentDay';
import { getStartDate } from '@akin-home/calendar';
import { useListCalendarItems } from '@akin-home/calendar/combined';
import { useHabitatID } from '@akin-home/habitats/react';
import { endOfWeek, isSameDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';

const useTodaysEvents = () => {
  const habitatID = useHabitatID();
  const day = useCurrentDay();

  const { today, start_of_today, end_of_week } = useMemo(() => {
    const today = new Date(day);

    return {
      today,
      start_of_today: startOfDay(today),
      end_of_week: endOfWeek(today),
    };
  }, [day]);

  const calendar = useListCalendarItems({
    params: {
      habitatID,
      filter: {
        from: start_of_today.toISOString(),
        to: end_of_week.toISOString(),
      },
    },
  });

  return {
    ...calendar,
    items: calendar.items.filter((i) => isSameDay(getStartDate(i), today)),
  };
};

export default useTodaysEvents;
